import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import React from "react";
import {EmblaIcons} from "../../../core/emblaIcons";
import {ActionIcon} from "../../../core/components/actionIcon/actionIcon";
import {ReactTooltip} from "../../../core/components/tooltips/ReactTooltip";
import {Loading} from "../../../core/components/loading/loading";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import {DashboardOpmaerksomhedspunkterEnum} from "./DashboardOpmaerksomhedspunkterEnum";

type DashboardOpmaerksomhedCardProps = {
    text: string;
    subjectText: string;
    amount: number;
    infoText?: string;
    isLoading: boolean;
    handleClickCallback?: () => void;
    opmaerksomhedspunkt: DashboardOpmaerksomhedspunkterEnum;
}
export const DashboardOpmaerksomhedCard = ({
                                               text,
                                               subjectText,
                                               amount,
                                               infoText,
                                               isLoading,
                                               handleClickCallback,
                                               opmaerksomhedspunkt
                                           }: DashboardOpmaerksomhedCardProps) => {
    const {isMobile} = useScreenResolution();
    return (
        <div className="flex-container-row flex-fill border-bottom align-items-center  wrap">
            <Loading isLoading={isLoading} spinnerSize={"exstra-small"}>
                {amount > 0
                    ?
                    <EmblaIcon iconName={EmblaIcons.Warning} size={"huge"}
                               additionalClasses={"fill-warning-dark margin-right-s"}
                    />
                    :
                    <EmblaIcon iconName={EmblaIcons.Tasks} size={"huge"}
                               additionalClasses={"fill-success-dark margin-right-s rounded-circle"}
                    />
                }
            </Loading>
            <b className={"margin-right-xs"}>{`${subjectText}:`}</b>
            <div className={"margin-right-xs font-weight-bold"}>{`${!isLoading ? amount : ""}`}</div>
            {!isMobile &&
                <div>{text}</div>
            }
            {infoText &&
                <div className={"margin-left-xs"}>
                    <div id={"tooltip-" + opmaerksomhedspunkt + "info-icon-id"}>
                        <EmblaIcon iconName={EmblaIcons.Info}/>
                    </div>
                    <ReactTooltip selectId={"tooltip-" + opmaerksomhedspunkt + "info-icon-id"}>
                        <div>{infoText}</div>
                    </ReactTooltip>
                </div>
            }
            {handleClickCallback &&
                <ActionIcon addtionalClassNames={"flex-align-r"} iconName="arrow-right" action={handleClickCallback} showCircle={false}/>
            }
        </div>
    );
}
